import axiosIns from '@/libs/axios'

// Sayfa öğeleri (Sayfalar › Düzenle › Sayfa Öğeleri): bölüm, BM amacı, PDF belge
const ROOT_URL = '/Admin/data/content_items'
export default {
  namespaced: true,
  state: {
    dataList: [],
  },
  getters: {
    dataList(state) {
      return state.dataList
    },
  },
  mutations: {
    SET_DATA_LIST(state, data) {
      state.dataList = data
    },
  },
  actions: {
    getDataList({ commit }, idContents) {
      const data = JSON.stringify({
        where: {
          'content_items.id_contents': idContents,
        },
      })
      return axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_LIST', response.data.data || [])
        })
        .catch(error => console.error(error))
    },
    saveData(context, postData) {
      return axiosIns
        .post(`${ROOT_URL}/saveData`, JSON.stringify(postData))
        .then(response => response.data)
        .catch(error => console.error(error))
    },
    removeData(context, id) {
      return axiosIns
        .post(`${ROOT_URL}/deleteData`, { id })
        .then(response => response.data)
        .catch(error => console.error(error))
    },
  },
}
